import type { StreamProviderType, StreamProviderId } from '@/types/streaming';

export const radioCategories = [
  'Música',
  'Noticias',
  'Deportes',
  'Religiosa',
  'Comunitaria',
  'Cultural',
  'Educativa',
  'Entretenimiento',
  'Juvenil',
  'Adulto contemporáneo',
  'Rock',
  'Electrónica',
  'Tropical',
  'Regional',
  'Jazz / Blues',
  'Clásica',
  'Podcast',
  'Variada',
];

// ── Provider options (for registration form) ──
export interface StreamProviderOption {
  value: StreamProviderId;
  label: string;
  providerType: StreamProviderType;
  description: string;
}

export const streamProviderOptions: StreamProviderOption[] = [
  { value: 'icecast', label: 'Icecast', providerType: 'direct_server', description: 'Servidor de streaming estándar (MP3, AAC, OGG)' },
  { value: 'shoutcast', label: 'SHOUTcast', providerType: 'direct_server', description: 'Servidor de streaming clásico (MP3, AAC+)' },
  { value: 'azuracast', label: 'AzuraCast', providerType: 'managed_panel', description: 'Panel completo con AutoDJ y estadísticas' },
  { value: 'centovacast', label: 'Centova Cast', providerType: 'managed_panel', description: 'Panel de control con AutoDJ incluido' },
  { value: 'custom', label: 'Proveedor propio / Otro', providerType: 'custom_url', description: 'Cualquier servidor de streaming externo' },
];

// ── Protocol formats (for stream URL configuration) ──
export const streamFormats: string[] = ['MP3', 'AAC', 'AAC+', 'OGG', 'FLAC', 'Opus'];

export const streamTypes = [
  { value: 'icecast', label: 'Servidor de streaming (MP3/AAC)' },
  { value: 'hls', label: 'HLS (m3u8)' },
  { value: 'rtmp', label: 'RTMP' },
  { value: 'srt', label: 'SRT' },
  { value: 'webrtc', label: 'WebRTC' },
  { value: 'other', label: 'Otro' },
];

export const bitrateOptions = [
  { value: '64', label: '64 kbps — Básica' },
  { value: '96', label: '96 kbps' },
  { value: '128', label: '128 kbps — Estándar' },
  { value: '192', label: '192 kbps' },
  { value: '256', label: '256 kbps — Alta' },
  { value: '320', label: '320 kbps — Máxima' },
];

export const countries = [
  'Argentina',
  'Bolivia',
  'Chile',
  'Colombia',
  'Costa Rica',
  'Cuba',
  'Ecuador',
  'El Salvador',
  'España',
  'Guatemala',
  'Honduras',
  'México',
  'Nicaragua',
  'Panamá',
  'Paraguay',
  'Perú',
  'República Dominicana',
  'Uruguay',
  'Venezuela',
  'Estados Unidos',
  'Otro',
];

export const brandingColors = [
  { value: '#ef4444', label: 'Rojo fuego' },
  { value: '#f97316', label: 'Naranja' },
  { value: '#eab308', label: 'Amarillo' },
  { value: '#22c55e', label: 'Verde' },
  { value: '#14b8a6', label: 'Turquesa' },
  { value: '#ec4899', label: 'Rosa' },
  { value: '#f43f5e', label: 'Fucsia' },
  { value: '#a855f7', label: 'Violeta' },
  { value: '#78716c', label: 'Café' },
  { value: '#facc15', label: 'Dorado' },
];